import { z } from 'zod';

import { CandidateReputationSchema } from './candidate-reputation';

export const AfcSubmissionCandidateReputationSchema =
  CandidateReputationSchema.extend({
    displayCandidateReputation: z.boolean().default(false),
  });

export type AfcSubmissionCandidateReputation = z.infer<
  typeof AfcSubmissionCandidateReputationSchema
>;
